"use strict";var dd=require("../core");require("../platform"),module.exports=dd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/entry/union.js
// module id = e33H
// module chunks = 0